// Utility to generate a cryptographically secure random string

const ALPHANUMERIC_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const NUMERIC_CHARS = '0123456789';
const ALPHABETIC_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const URL_SAFE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
const HEX_CHARS = '0123456789abcdef';

const cryptoRandomString = ({ length, type = 'alphanumeric', characters }) => {
    if (!length || length <= 0) {
        throw new Error('Length must be a positive number');
    }

    let charset = characters;
    if (!charset) {
        switch (type) {
            case 'alphanumeric':
                charset = ALPHANUMERIC_CHARS;
                break;
            case 'numeric':
                charset = NUMERIC_CHARS;
                break;
            case 'alphabetic':
                charset = ALPHABETIC_CHARS;
                break;
            case 'url-safe':
                charset = URL_SAFE_CHARS;
                break;
            case 'hex':
                charset = HEX_CHARS;
                break;
            default:
                charset = ALPHANUMERIC_CHARS;
        }
    }

    const charSetSize = charset.length;
    const randomBuffer = new Uint8Array(length);

    if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(randomBuffer);
    } else if (typeof global !== 'undefined' && global.crypto && global.crypto.getRandomValues) {
        global.crypto.getRandomValues(randomBuffer);
    } else {
        throw new Error('crypto.getRandomValues is not available');
    }

    let result = '';
    for (let i = 0; i < length; i++) {
        result += charset[randomBuffer[i] % charSetSize];
    }

    return result;
};

export default cryptoRandomString;

export const uuidv4 = () => {
    try {
        return crypto.randomUUID();
    } catch (e) {
        // Fallback: crypto.getRandomValues works in HTTP contexts unlike randomUUID()
        try {
            const bytes = new Uint8Array(16);
            crypto.getRandomValues(bytes);
            bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
            bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant bits
            const hex = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
            return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
        } catch (e2) {
            // Last resort for very old runtimes without any crypto support
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                const r = (Math.random() * 16) | 0;
                const v = c === 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    }
};
